import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formFrame_container: {
			display: 'flex',
			flexDirection: 'column',
			height: '100%',
			position: 'relative',
			outline: 'none',
		},
		formFrame_header: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				maxWidth: '1080px',
				margin: '0 auto',
				width: '100%',
			},
		},
		formFrame_scrollbar: {
			height: '100%',
		},
		formFrame_body: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				maxWidth: '1080px',
				margin: '0 auto',
				width: '100%',
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				maxWidth: '1080px',
				margin: '0 auto',
				width: '100%',
				flex: '1 0 auto',
			},
		},
		formFrame_footer: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				maxWidth: '1080px',
				margin: '0 auto',
				width: '100%',
			},
		},
	});
});

export default useStyles;
